import request from './request'

/**
 * 岗位列表
 * @param {object} [params] - 查询参数
 * @param {string} [params.code] - 岗位编码（模糊查询）
 * @param {string} [params.name] - 岗位名称（模糊查询）
 * @param {boolean} [params.status] - 状态：true-启用，false-禁用
 * @param {number} [params.page] - 当前页码
 * @param {number} [params.size] - 每页大小
 */
export function getPosts(params) {
  return request.get('/org/posts', { params })
}

/**
 * 获取岗位详情
 * @param {number} id - 岗位ID
 */
export function getPost(id) {
  return request.get(`/org/posts/${id}`)
}

/**
 * 新增岗位
 * @param {object} data - 岗位信息
 * @param {string} data.name - 岗位名称
 * @param {string} data.code - 岗位编码
 * @param {string} [data.alias] - 别名简称
 * @param {string} [data.postLevel] - 岗位职级
 * @param {number} [data.sort] - 显示顺序
 * @param {boolean} [data.status] - 状态：true-启用，false-禁用
 * @param {string} [data.remark] - 备注
 */
export function createPost(data) {
  return request.post('/org/posts', data)
}

/**
 * 修改岗位
 * @param {number} id - 岗位ID
 * @param {object} data - 岗位信息
 * @param {number} data.id - 岗位ID
 * @param {string} data.name - 岗位名称
 * @param {string} data.code - 岗位编码
 * @param {string} [data.alias] - 别名简称
 * @param {string} [data.postLevel] - 岗位职级
 * @param {number} [data.sort] - 显示顺序
 * @param {boolean} [data.status] - 状态：true-启用，false-禁用
 * @param {string} [data.remark] - 备注
 */
export function updatePost(id, data) {
  return request.put(`/org/posts/${id}`, data)
}

/**
 * 删除岗位
 * @param {number} id - 岗位ID
 */
export function deletePost(id) {
  return request.post(`/org/posts/${id}/delete`)
}
